export * from './infiniteLoader.types';
export { default as InfiniteLoader } from './infiniteLoader.component';
